import React, { useState } from 'react'
import Contact from "../Contact/Contact";
import FormAsesoramiento from './FormAsesoramiento/FormAsesoramiento';
import './inicio.css'
import CelulasMadre from './CelulasMadre/CelulasMadre';
import BeneficiosCriopreservar from './BeneficiosCriopreservar/BeneficiosCriopreservar';
import { primerDiaTitle, primerDiaParrafo, primerDiaParrafoMobile, whatsapp } from './data'
import Servicos from './Servicios/Servicos';
import CyclicLine from './CyclicLine/CyclicLine';
import { WhatsappButton } from '../Whatsapp/WhatsappButton';
import Navbar from "../Navbar/Navbar";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { FaTimes } from "react-icons/fa";
import { FiAlertCircle } from "react-icons/fi";
import moment from "moment-timezone";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles((theme) => ({
    menuButton: {
        fontFamily: 'Red Hat Display',
        size: "40px",
        fontSize: "14px",
        background: "#00748b 0% 0% no-repeat padding-box",
        borderRadius: "20px",
        opacity: "1",
        color: "#ffffff",
        width: "250px !important",
        textTransform: "capitalize",
        paddingRight: 20,

        height: "40px",
        "&:hover": {
            color: "#ffffff",
        },
    },
    noMarginBottom: {
        marginBottom: 0,
    },
}));

const Inicio = () => {
    const [open, setOpen] = useState(false);
    const { menuButton, noMarginBottom } = useStyles();
    const nowArg = moment().tz("America/Argentina/Buenos_Aires");
    const migrationsEndDate = moment.tz("2025-06-20 20:00:00", "America/Argentina/Buenos_Aires");
    const warningStartDate = moment.tz("2025-05-26 00:00:00", "America/Argentina/Buenos_Aires");
    const warningEndDate = moment.tz("2025-06-20 00:00:00", "America/Argentina/Buenos_Aires");
    const [viewedWarning, setViewedWarning] = useState(false);
    let history = useHistory()

    const handleOpen = () => {
        setOpen(true);
        if (nowArg.isBetween(warningStartDate, warningEndDate, null, "[]")) {
            setViewedWarning(true);
        }
    }

    const handleClick = () => {
        history.push("/login-clientes")
    }
    const handleClose = () => {
        setOpen(false);
    }
    return (
        <div>
            {/* <Navigation/> */}
            <Navbar handleOpen={handleOpen} viewedWarning={viewedWarning} migrationsEndDate={migrationsEndDate} warningStartDate={warningStartDate} warningEndDate={warningEndDate}
            />
            <main className="containerMain">
                <div className="containerAsesoramiento">
                    <img src="img/new_portada.png" className="img-custom-mama" alt="Mamá" />
                    <div className='mobileTitlePrimerDia'>
                        {primerDiaTitle.map((title) => <h1 key={title.key} className="titlePrimerDiaMobile">{title.title}</h1>)}
                    </div>
                    <div className='containerPrimerDiaParrafoMobile'>
                        {primerDiaParrafoMobile.map((parrafo) => <p key={parrafo.key} className="paragraphPrimerDiaMobile" >{parrafo.text}</p>)}
                    </div>
                    <div className="containerPrimerDia">
                        {primerDiaTitle.map((title) => <h1 key={title.key} className="titlePrimerDia">{title.title}</h1>)}
                        {primerDiaParrafo.map((primerDia) => <p key={primerDia.key} className="paragraphPrimerDia">{primerDia.text}</p>)}
                    </div>
                    <FormAsesoramiento handleOpen={handleOpen} viewedWarning={viewedWarning} migrationsEndDate={migrationsEndDate} warningStartDate={warningStartDate} warningEndDate={warningEndDate} />
                </div>
                <div className="containerRest">
                    <CelulasMadre />
                    <CyclicLine />
                    <BeneficiosCriopreservar />
                    <Servicos />

                </div>

            </main>
            <Contact />
            <WhatsappButton src={whatsapp.src} />
            <Dialog open={open} onClose={handleClose}>
                <div style={{ display: "flex", marginLeft: 24, marginRight: 24, marginTop: 10, borderRadius: 10 }}>
                    <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
                        <FiAlertCircle style={{ fontSize: 50, marginTop: 10 }} />
                        <DialogTitle style={{ marginLeft: -10 }} id="form-dialog-title">Información importante</DialogTitle>
                    </div>
                    <button style={{
                        position: "relative",
                        bottom: 50,
                        right: 540,
                        background: "transparent",
                        border: "none",
                        color: "white",
                        cursor: "default",
                        padding: 0,
                        outline: "none"
                    }} onClick={handleClick}>Login</button>
                    <FaTimes onClick={handleClose} style={{ marginTop: 24, marginBottom: 16, cursor: "pointer", fontSize: 20 }} />
                </div>
                <DialogContent>
                    {
                        nowArg.isBetween(warningStartDate, warningEndDate, null, "[]") ?
                            <>
                                <DialogContentText>Por tareas de mantenimiento, nuestros canales digitales y de atención no estarán disponibles desde el <strong>viernes 20 a las 00</strong> hasta el <strong>sábado 21</strong> de <strong>junio</strong></DialogContentText>
                                <DialogContentText>¡Gracias por tu comprensión!</DialogContentText>
                            </>
                            :
                            <DialogContentText>
                                Por tareas de mantenimiento, nuestros canales digitales no están disponibles.
                                <br></br>
                                <br></br>
                                <DialogContentText className={noMarginBottom} >Nuestras clínicas, guardias y la línea de emergencias siguen funcionando.</DialogContentText>
                                <DialogContentText ><strong>En caso de una emergencia médica, podés comunicarte al 0800-777-7800.</strong></DialogContentText>
                                <br></br>
                                Atenderemos las consultas administrativas cuando se recupere el servicio.
                            </DialogContentText>
                    }

                </DialogContent>
                <DialogActions style={{ marginBottom: 10 }}>
                    <button
                        className={menuButton}
                        style={{
                            background: "#eb0000", color: "#ffffff", backgroundColor: "#00748b"
                        }}
                        onClick={handleClose}
                    >
                        Entendido
                    </button>
                </DialogActions>
            </Dialog>
        </div>

    )
}

export default Inicio
